// @flow

import type {FormState} from '@/types'

import {merge} from 'ramda'

const initialState: FormState = {
  id: null,
  type: null,
  data: null,
}

export default (state: FormState = initialState, action: any): FormState => {
  switch (action.type) {
    case 'SETUP_FORM':
      return {
        type: action.formType,
        id: action.id,
      }
    case 'STORE_FORM_FIELD':
      return {
        ...state,
        data: merge(state.data, action.data),
      }
    case 'CLOSE_MODAL':
      if (action.modalType === 'import') {
        return {
          ...state,
          data: null,
        }
      }
      return {
        ...state,
      }
    case 'SET_FORM_DATA':
      return {
        ...state,
        data: action.data,
      }
    case 'CLEAR_FORM':
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/form/reducer.js